import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_PETITION_PAGE_DM_CONSTITUENCY_CONFIG = createFcmDetails(
	'petition_page_dm_constituency_config',
	{
		owner: 'Capybara',
		context: 'New petition page DM card',
		description: 'Provides number of signers part of decision maker constituents',
		import: false,
		template: {
			readEnabled: false, // meant for triggering fetching data from backend service
			enabled: false, // meant for triggering fetching data from FC
			constituents: [],
			relevantNormalizedPositionNames: [
				'City Legislature',
				'County Legislature//Executive Board',
				'Township Trustee//Township Council',
				'State Representative',
				'State Senator',
				'U.S. Representative',
				'City Executive//Mayor',
				'Township Supervisor',
				'Township Mayor',
			],
		},
	},
);
